import React, { useState } from "react";
import { fetchBatch, buySubscription, fetchPackages, getPlansByPackageId } from "../../lib/Subscription";
import { getClasses } from "../../lib/ClassApi";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getSubjectsByclassId, getCoursesByclassId } from "../../lib/ClassApi"

const SubscriptionPage = () => {
  const navigate = useNavigate();

  const [classList, setClassList] = useState([]);
  const [subjectsList, setSubjectsList] = useState([]);
  const [batchList, setBatchList] = useState([]);

  //
  const [courseList, setCourseList] = useState([]);
  const [packageList, setPackageList] = useState([]);
  const [planList, setPlanList] = useState([]);
  //

  const [userData, setUserData] = useState(null);

  //get userProfile===============
  useEffect(() => {

    const storedUser = JSON.parse(localStorage.getItem("user")) || [];

    if (storedUser) {
      setUserData(storedUser);

      // auto fill current class
      setForm((prev) => ({
        ...prev,
        classId: storedUser.classId || ""
      }));
    }
  }, []);

  //===========course Amount ==========
  // const getAmount = () => {
  //   switch (form.plan) {
  //     case "full": return 24000;
  //     case "halfyearly": return 12000;
  //     case "quarterly": return 7200;
  //     case "monthly": return 2400;
  //     default: return 0;
  //   }
  // };

  const [form, setForm] = useState({
    classId: '',
    
    type: "New",

    courseIds: [],

    batchId: "",

    packageId: "",

    planId: "",

    amount: 0,

    paymentMethod: "UPI",
  });
  // const handleChange = (field, value) => {
  //   setForm({ ...form, [field]: value });
  // };
  const handleChange = (field, value) => {

    if (field === "classId") {

      setForm({
        ...form,

        classId: value,

        courseIds: [],

        batchId: "",

        packageId: "",

        planId: "",

        amount: 0
      });

      setBatchList([]);
      setPackageList([]);
      setPlanList([]);

      return;
    }

    if (field === "batchId") {

      setForm({
        ...form,

        batchId: value,

        packageId: "",

        planId: "",

        amount: 0
      });

      setPackageList([]);
      setPlanList([]);

      return;
    }

    if (field === "packageId") {

      setForm({
        ...form,

        packageId: value,

        planId: "",

        amount: 0
      });

      setPlanList([]);

      return;
    }
    setForm({
      ...form,
      [field]: value
    });
  };

  // const handleCheckbox = (field, value) => {
  //   const exists = form[field].includes(value);
  //   setForm({
  //     ...form,
  //     [field]: exists
  //       ? form[field].filter((v) => v !== value)
  //       : [...form[field], value],
  //   });
  // };


  //=========== Fetch class list===========
  const handleCheckbox = (field, value) => {

    const exists = form[field].includes(value);

    const updatedValues = exists
      ? form[field].filter((v) => v !== value)
      : [...form[field], value];

    setForm({
      ...form,

      [field]: updatedValues,

      batchId: "",

      packageId: "",

      planId: "",

      amount: 0
    });

    setBatchList([]);
    setPackageList([]);
    setPlanList([]);
  };

  useEffect(() => {
    const fetchClasses = async () => {
      const res = await getClasses(-1);
      if (res.success) setClassList(res.data);
    };
    fetchClasses();
  }, []);
  //==============Fetch Subject list=============
  // useEffect(() => {
  //   fetchSubjects(form.classId);
  // }, [form.classId]);

  // const fetchSubjects = async (classId) => {
  //   try {
  //     const res = await getSubjectsByclassId(classId);

  //     if (res.success) {
  //       setSubjectsList(res.data);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  //=============Fetch Course list==========
  const fetchCourses = async (classId) => {
    try {
      const res = await getCoursesByclassId(classId);

      if (res.success) {
        setCourseList(res.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (form.classId) {
      fetchCourses(form.classId);
    }
  }, [form.classId]);

  //==========Fetch  Batch==========
  // useEffect(() => {
  //   if (form.classId && form.subjects.length > 0) {
  //     fetchBatches(form.classId, form.subjects[0]);
  //   }
  // }, [form.classId, form.subjects]);

  useEffect(() => {
    if (
      form.classId &&
      form.courseIds.length > 0
    ) {
      fetchBatches();
    }
  }, [form.classId, form.courseIds]);


  // const fetchBatches = async (classId, subjectId) => {
  //   try {
  //     const res = await fetchBatch(classId, subjectId);

  //     if (res.success) {
  //       setBatchList(res.data); // HERE ONLY
  //     }
  //   } catch (err) {
  //     console.error("Batch API Error:", err);
  //   }
  // };



  //==============Handle subscription===================

  const fetchBatches = async () => {
    try {

      const payload = {
        classId: Number(form.classId),

        courseIds: form.courseIds
      };

      console.log("BATCH PAYLOAD:", payload);

      const res = await fetchBatch(payload);

      console.log("BATCH RESPONSE:", res);

      if (res.success) {
        setBatchList(res.data);
      }

    } catch (err) {
      console.error("Batch API Error:", err);
    }
  };

  //=============fetch packages==============
  useEffect(() => {

    if (
      form.batchId &&
      form.courseIds.length > 0
    ) {
      getPackages();
    }

  }, [form.batchId, form.courseIds]);


  const getPackages = async () => {

    try {

      const payload = {

        batchId: Number(form.batchId),

        courseIds: form.courseIds
      };

      console.log(
        "PACKAGE PAYLOAD:",
        payload
      );

      const res = await fetchPackages(payload);

      console.log(
        "PACKAGE RESPONSE:",
        res
      );

      if (res.success) {
        setPackageList(res.data);
      }

    } catch (err) {

      console.error(
        "Package API Error:",
        err
      );
    }
  };

  //=============Fetch Package Plan=============
  useEffect(() => {

    if (form.packageId) {
      fetchPlans(form.packageId);
    }

  }, [form.packageId]);

  const fetchPlans = async (packageId) => {

    try {

      const res =
        await getPlansByPackageId(packageId);

      console.log(
        "PLANS RESPONSE:",
        res
      );

      if (res.success) {

        setPlanList(res.data);
      }

    } catch (err) {

      console.error(
        "Plan API Error:",
        err
      );
    }
  };





  const handlePay = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");

      //  Validation
      if (!form.classId) return alert("Select class");
      //if (form.subjects.length === 0) return alert("Select subjects");
      if (!form.batchId) return alert("Select batch");
      if (!form.packageId)
        return alert("Select package");
      if (!form.planId)
        return alert("Select plan");
      console.log("=======UserId======= :", user.uuid);
      const payload = {
        userId: user.uuid,
        classId: Number(form.classId),
        batchId: Number(form.batchId),
        packageId: Number(form.packageId),

        courseIds: form.courseIds,

        planId: Number(form.planId),

        amount: Number(form.amount),
        // planId: form.plan === "full" ? 1 :
        //   form.plan === "halfyearly" ? 2 :
        //     form.plan === "quarterly" ? 3 : 4,

        // subjectIds: form.subjects,

        // planType: form.plan,
        // amount:0,

        paymentStatus: "SUCCESS",
        paymentMode: form.paymentMethod,

        paymentId: "pay_test_123",
        razorpayOrderId: "order_test_123"
      };

      console.log("FINAL PAYLOAD:", payload);

      const res = await buySubscription(payload);
      if (res.success) {
        alert("Subscription Created Successfully");
        navigate("/live-classes");
      }

      // if (res.success) {
      //   alert("Subscription Created Successfully ");
      // } else {
      //   alert(res.message || "Subscription failed ");
      // }

    } catch (err) {
      console.error("FULL ERROR:", err);

      if (err.response) {
        console.error("API ERROR:", err.response.data);
        alert(err.response.data?.message || "API Error ");
      } else {
        alert("Server not reachable ");
      }
    }
  };

  //====================DateTime formatter helper===========
  const formatTime = (timeObj) => {
    if (!timeObj?.hasValue) return "";

    const hours = timeObj.value.hours;
    const minutes = timeObj.value.minutes;

    const period = hours >= 12 ? "PM" : "AM";

    const formattedHour =
      hours % 12 || 12;

    return `${formattedHour}:${minutes
      .toString()
      .padStart(2, "0")} ${period}`;
  };

  return (
    <>
      <div className=" bg-secondary flex flex-col items-start px-4 py-6 md:px-10">
        {/* Logo */}
        <div className="text-center mb-8 ">
          {/* Logo */}
          <div className="bg-[#1e1e1e] rounded-xl px-6 py-3 flex items-center">
            <span className="text-white text-2xl md:text-3xl font-['Great_Vibes']">
              Insta
            </span>
            <span className="text-white text-4xl md:text-5xl font-black ml-1">
              ED
            </span>
          </div>
          <p className="text-sm md:text-base text-gray-600">
            Online Tuitions | 6-12
          </p>


        </div>

      </div>
      {/* {userData && (
        <div className="flex items-center gap-3">
          <img
            src={
              userData.profileImage ||
              "https://i.pravatar.cc/60"
            }
            alt="profile"
            className="w-12 h-12 rounded-full object-cover"
          />

          <div>
            <p className="font-semibold">
              {userData.firstName} {userData.lastName}
            </p>
            <p className="text-sm text-gray-500">
              {userData.className}
            </p>
          </div>
        </div>
      )} */}

      <div className="min-h-screen bg-secondary flex flex-col items-center">
        {/* TITLE */}
        <h1 className="text-center font-semibold text-black mb-6">
          Buy / Renew Subscription
        </h1>

        {/* MAIN */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto">

          {/* LEFT */}
          <div className="w-full max-w-[320px] flex flex-col gap-4">

            {/* Top Banner */}
            <div className="bg-primary text-white rounded-md px-5 flex items-center h-[90px]">
              <p className="font-semibold text-[22px]">
                @ INR 1200 / subject / month*
              </p>
            </div>

            {/* Card 1 */}
            <div className="bg-primary text-white rounded-md p-5 h-[130px] flex flex-col justify-center">
              <p className="font-semibold text-[27px]">Fee for Class 6-10</p>
              <p className="font-semibold">INR 24,000 per year*</p>
              <p className="text-xs mt-2">Math & Science</p>
            </div>

            {/* Card 2 */}
            <div className="bg-primary text-white rounded-md p-5 h-[130px] flex flex-col justify-center">
              <p className="font-semibold text-[27px]">Fee for Class 11-12</p>
              <p className="font-semibold">INR 36,000 per year*</p>
              <p className="text-xs mt-2">Math / Bio / Che / Phy</p>
            </div>



            <p className="text-[15px] mt-4">
              *on full one-time fee payment plan. 2 months discount applied.
              Applicable fee for other payment plans @ Rs 2400 per month
            </p>
          </div>

          {/* RIGHT */}
          <div className="relative pl-6 border-l border-gray-400 text-sm">

            <p className="mb-2">
              Hi, you are subscribing to InstaED.{" "}
              <span className="float-right">
                <b>Current:</b> {userData?.className || "-"}
              </span>
            </p>

            {/* Class */}
            <div className="mb-3">
              <span className="font-medium text-primary font-semibold">
                Class you’re subscribing/ renewing to:
              </span>{" "}
              <select
                value={form.classId}
                onChange={(e) => handleChange("classId", e.target.value)}
              >
                <option value="">Select Class</option>

                {classList.map((cls) => (
                  <option key={cls.id} value={cls.id}>
                    {cls.classname}
                  </option>
                ))}
              </select>
            </div>

            {/* Subscription Type */}
            <div className="mb-3 flex items-center gap-4">
              <span className="font-medium text-primary font-semibold">Subscription type:</span>

              <label className="flex items-center gap-1">
                <input
                  type="checkbox"
                  checked={form.type === "renewal"}
                  onChange={() => handleChange("type", "renewal")}
                />
                Renewal
              </label>

              <label className="flex items-center gap-1">
                <input
                  type="checkbox"
                  checked={form.type === "new"}
                  onChange={() => handleChange("type", "new")}
                />
                New
              </label>
            </div>

            {/* Subjects */}
            {/* <div className="mb-3 flex items-center flex-wrap gap-3">
              <span className="font-medium">Select subjects:</span>

              {["Math", "Science", "Bio", "Phy", "Che"].map((sub) => (
                <label key={sub} className="flex items-center gap-1">
                  <input
                    type="checkbox"
                    checked={form.subjects.includes(sub)}
                    onChange={() => handleCheckbox("subjects", sub)}
                  />
                  {sub}
                </label>
              ))}
            </div> */}
            {/* <div className="mb-3 flex items-center flex-wrap gap-3">
              <span className="font-medium text-primary font-semibold">Select subjects:</span>

              {subjectsList.map((sub) => (
                <label key={sub.subjectId} className="flex items-center gap-1">
                  <input
                    type="checkbox"
                    checked={form.subjects.includes(sub.subjectId)}
                    onChange={() => handleCheckbox("subjects", sub.subjectId)}
                  />
                  {sub.subjectName}
                </label>
              ))}
            </div> */}

            {/*Course List*/}

            <div className="mb-3 flex items-center flex-wrap gap-3">
              <span className="font-medium text-primary font-semibold">
                Select Courses:
              </span>

              {courseList.map((course) => (
                <label
                  key={course.courseId}
                  className="flex items-center gap-1"
                >
                  <input
                    type="checkbox"
                    checked={form.courseIds.includes(course.courseId)}
                    onChange={() =>
                      handleCheckbox("courseIds", course.courseId)
                    }
                  />

                  {course.courseName}
                </label>
              ))}
            </div>

            {/* Academic */}
            <div className="mb-3">
              <span className="font-medium text-primary font-semibold">Academic session:</span>{" "}
              Apr 2026–Mar 2027
            </div>

            {/* Weekdays */}
            <span className="font-medium text-primary">Select Batch:</span>

            {/*GetBatch */}

            {/* <select
              className="border p-2 rounded"
              value={form.batchId}
              onChange={(e) => handleChange("batchId", e.target.value)}
            >
              <option>Select Batch</option>
              {batchList.map((b) => (
                <option key={b.batchId} value={b.batchId}>
                  {b.batchtype} {formatTime(b.startTime)} - {formatTime(b.endTime)}
                </option>
              ))}
            </select> */}

            <select
              className="border p-2 rounded w-full"
              value={form.batchId}
              onChange={(e) =>
                handleChange("batchId", e.target.value)
              }
            >
              <option value="">
                Select Batch
              </option>

              {batchList.map((b) => (
                <option
                  key={b.batchId}
                  value={b.batchId}
                >
                  {b.batchName} (
                  {formatTime(b.startTime)}
                  {" - "}
                  {formatTime(b.endTime)})
                </option>
              ))}
            </select>

            {/*Get Packages */}
            <div className="mt-4">

              <span className="font-medium text-primary font-semibold">
                Available Packages:
              </span>

              <div className="flex flex-col gap-3 mt-2">

                {packageList.map((pkg) => (

                  <label
                    key={pkg.packageId}
                    className="border rounded p-3 flex items-start gap-2"
                  >

                    <input
                      type="radio"
                      name="packageId"
                      checked={
                        Number(form.packageId) ===
                        pkg.packageId
                      }
                      onChange={() =>
                        handleChange(
                          "packageId",
                          pkg.packageId
                        )
                      }
                    />

                    <div>

                      <p className="font-semibold">
                        {pkg.packageName}
                      </p>

                      <p className="text-sm text-gray-500">
                        {pkg.description}
                      </p>

                    </div>

                  </label>

                ))}

              </div>

            </div>

            {/* Payment Plan */}
            {/* <div className="mb-4">
              <p className="font-medium mb-2 text-primary font-semibold">
                Select the payment plan:
              </p>

              <div className="space-y-2">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="plan"
                    checked={form.plan === "full"}
                    onChange={() => handleChange("plan", "full")}
                  />
                  Full/ One-time (Rs 24,000)
                  <span className="line-through text-xs ml-2">
                    28,800
                  </span>
                  <span className="text-xs ml-2">
                    Discount: Rs 4800 (2 months)
                  </span>
                </label>

                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="plan"
                    checked={form.plan === "halfyearly"}
                    onChange={() => handleChange("plan", "halfyearly")}
                  />
                  Half-Yearly (Rs 12,000)
                </label>

                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="plan"
                    checked={form.plan === "quarterly"}
                    onChange={() => handleChange("plan", "quarterly")}
                  />
                  Quarterly (Rs 7,200)
                </label>

                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="plan"
                    checked={form.plan === "monthly"}
                    onChange={() => handleChange("plan", "monthly")}
                  />
                  Monthly (Rs 2,400)
                </label>
              </div>
            </div> */}

            <div className="mb-4">

              <p className="font-medium mb-2 text-primary font-semibold">
                Select the payment plan:
              </p>

              <div className="space-y-3">

                {planList.map((plan) => (

                  <label
                    key={plan.id}
                    className="flex items-start gap-3 border rounded p-3"
                  >

                    {/* <input
                      type="radio"
                      name="plan"
                      checked={
                        Number(form.planId) ===
                        plan.planId
                      }
                      onChange={() => {
                        setForm((prev) => ({
                          ...prev,
                          planId: plan.planId,
                          amount: plan.discountPrice
                        }));
                      }}
                    /> */}
                    <input
                      type="radio"
                      name="plan"
                      checked={
                        Number(form.planId) === plan.planId
                      }
                      onChange={() => {
                        setForm((prev) => ({
                          ...prev,
                          planId: plan.planId,
                          amount: plan.discountPrice
                        }));
                      }}
                    />

                    <div>

                      <p className="font-semibold">
                        {plan.planName}
                      </p>

                      <p className="text-sm text-gray-500">
                        Duration:
                        {" "}
                        {plan.durationDays}
                        {" "}
                        Days
                      </p>

                      <div className="flex gap-2 items-center">

                        <span className="line-through text-gray-400">
                          ₹{plan.actualPrice}
                        </span>

                        <span className="font-bold text-green-600">
                          ₹{plan.discountPrice}
                        </span>

                      </div>

                    </div>

                  </label>

                ))}

              </div>

            </div>

            {/* Payment Method */}
            <div className="mb-4">
              <p className="font-medium mb-2 text-primary font-semibold">
                How do you wish to pay?
              </p>

              {["Debit Card/ Credit Card", "Internet Banking", "UPI", "GPay/ Paytm"].map((method) => (
                <label key={method} className="flex items-center gap-2 mb-1">
                  <input
                    type="radio"
                    name="paymentMethod"
                    checked={form.paymentMethod === method}
                    onChange={() => handleChange("paymentMethod", method)}
                  />
                  {method}
                </label>
              ))}
            </div>

            {/* Button */}
            <div className="flex items-center gap-4 bg-bS">
              <button
                onClick={() => {
                  console.log("BUTTON CLICKED");
                  handlePay();
                }}
                className="bg-[#1e1e1e] text-white px-4 py-1 text-sm rounded"
              >
                Pay
              </button>
              <span className="text-xs underline cursor-pointer">
                Refund policy
              </span>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="text-center text-xs mt-10 text-gray-600">
          2026 | Edworks | Terms of Use | Privacy Policy
        </div>
      </div>
    </>
  );
};

export default SubscriptionPage;